
package com.tixforgigs.common.ui.components.icons

enum class Icon(val value: String) {
  TAG("tag"),
  LOGIN("login"),
  LOGOUT("logout"),
  CHECK("check"),
  CLOSE("close"),
  CLOCK("clock"),
  SEARCH("search"),
  EDIT("edit"),
  ADD("add"),
  REMOVE("remove"),
  INFO("info"),
  SAVE("save"),
  REDEEM("redeem"),
  ATTACH_MONEY("attach_money"),
  CLOUD_UPLOAD("cloud_upload"),
  SHOPPING_CART("shopping_cart"),
  DELETE("delete"),
  SCHEDULE("schedule"),
  SENSOR_DOOR("sensor_door"),
  MAP_PIN_HEART("map_pin_heart"),
  LOCAL_ACTIVITY("local_activity"),
  PAYMENTS("payments"),

  ;

  override fun toString(): String = value
}